module.exports = __webpack_public_path__ + "static/media/otherThings1.10d1e5e4.png";